import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

// common
import { KEYS_QUERY } from 'common/constants';
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceUserDetail } from 'modules/account/types';

// export type UserDetail = typeof schemas.UserData._type;
export type UserDetail = ReplaceUserDetail;

/**
 * Thông tin tài khoản
 */
const useGetAccountInfo = () => {
  const urlParams = useParams();
  const service = useService();

  return useQuery({
    queryKey: [KEYS_QUERY.accountDetail, urlParams.id || ''],
    queryFn: async () => {
      try {
        if (!service) return null;

        const res: UserDetail = await service.UserManagementController_getUserData({
          params: { userId: urlParams.id || '' },
        });
        return res;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useGetAccountInfo;

export const defaultUserDetail: UserDetail = {
  id: '',
  name: '',
  givenName: '',
  title: '',
  miscData: {
    JobPosition: '',
    Phone: '',
    Address: '',
    IdDoc: '',
    IdDocIssuedAt: '',
    IdDocIssuedBy: '',
    Dob: '',
    Gender: '',
  },
  updatedAt: '',
  /**
   * custom key, để hiển thị cho trường email trong tab Thông tin người dùng,
   *
   * ưu tiên hiển thị giá trị của email,
   *
   * nếu không có thì hiển thị giá trị của unverifiedEmail
   */
  email: '',

  /**
   * custom key, để hiển thị cho toggle switch Không thời hạn
   */
  noExpired: false,

  /**
   * custom key, để hiển thị cho toggle switch Trạng thái quản trị
   */
  status: true,
};
